<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-title class="font-weight-bold">Start Subscription</v-list-item-title>
      </v-list-item>
    </template>

    <v-card class="rounded-xl">
      <v-card-title class="headline" primary-title>
        Start Subscription
      </v-card-title>
      <v-container grid-list-lg>
        <div>
          <h5>Plans</h5>
          <v-item-group mandatory v-model="planIndex">
            <v-container>
              <v-row>
                <v-col v-for="(n, i) in plans" :key="i" cols="6">
                  <v-item v-slot="{ active, toggle }">
                    <v-card :color="active ? 'primary' : ''" class="d-flex align-center" dark @click="toggle">
                      <v-card-text>
                        <div :class="active ? 'font-weight-bold' : ''" class="text-center white--text">
                          {{ n }}
                        </div>
                      </v-card-text>
                      <!-- <v-scroll-y-transition>
                              <div
                                v-if="active"
                                class="text-h2 flex-grow-1 text-center"
                              >
                                Active
                              </div>
                            </v-scroll-y-transition> -->
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
          <div class="text-center display-2">{{ plans[planIndex] }}</div>
          <div v-if="stripePlans.length !== 0">
            <v-list dense v-if="planIndex === 1">
              <v-list-item v-for="item in stripePlans" v-if="item.recurring.interval === 'year'" :key="item.id">
                <v-list-item-content class="pa-0 text-capitalize">
                  <v-list-item-title>
                    {{ item.metadata.package }} package</v-list-item-title>
                  <v-list-item-subtitle>{{ item.metadata.employeeCount }} attendee
                    {{ (item.unit_amount / 100) | currency }}
                    {{ item.recurring.interval }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-card flat color="grey lighten-3" class="rounded-lg">
                    <v-card-text>
                      <v-layout row align-center>
                        <v-btn text icon :disabled="item.quantity === 0 ? true : false" @click="minusQty(item)">
                          <v-icon small color="black">mdi-minus</v-icon>
                        </v-btn>
                        <div class="black--text px-2">
                          {{ item.quantity }}
                        </div>

                        <v-btn text icon @click="addQty(item)">
                          <v-icon small color="black">mdi-plus</v-icon>
                        </v-btn>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-list dense v-else>
              <v-list-item v-for="item in stripePlans" v-if="item.recurring.interval === 'month'" :key="item.id">
                <v-list-item-content class="pa-0 text-capitalize">
                  <v-list-item-title>
                    {{ item.metadata.package }} package</v-list-item-title>
                  <v-list-item-subtitle>{{ item.metadata.employeeCount }} attendee
                    {{ (item.unit_amount / 100) | currency }}
                    {{ item.recurring.interval }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-card flat color="grey lighten-3" class="rounded-lg">
                    <v-card-text>
                      <v-layout row align-center>
                        <v-btn text icon :disabled="item.quantity === 0 ? true : false" @click="minusQty(item)">
                          <v-icon small color="black">mdi-minus</v-icon>
                        </v-btn>
                        <div class="black--text px-2">
                          {{ item.quantity }}
                        </div>

                        <v-btn text icon @click="addQty(item)">
                          <v-icon small color="black">mdi-plus</v-icon>
                        </v-btn>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
          <div v-else class="text-center">
            <v-progress-circular class="mt-5" indeterminate color="primary"></v-progress-circular>
            <div>Getting plans</div>
          </div>
        </div>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text @click="dialog = false" color="primary">Close</v-btn>
        <v-spacer></v-spacer>
        <!-- <v-btn text @click="dialog = false" color="primary">Done</v-btn> -->
        <v-btn small @click="startSub" :loading="loading" color="primary">Start</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import publicService from "@/api/public";
import locationService from "@/modules/Location/service.js";

export default {
  name: "start-subscription",
  props: [
    "subscription",
    "customer",
    "upComingInvoice",
    "location",
  ],
  data() {
    return {
      loading: false,
      planIndex: 0,
      plans: ["Monthly", "Yearly"],
      items: null,
      dialog: false,
      stripePlanId: null,
      stripePlans: [],
      interval: "year",
      currentInterval: null,
      employeeCount: 0,
      chargeAmount: 0,
    };
  },
  watch: {
    async dialog(val) {
      if (val) {
        await this.getPlans();

        this.setPlan();
      }
    },
    planIndex(val) {
      // this.items = this.plans[val];
      if (val === 0) {
        this.interval = "month";
      } else {
        this.interval = "year";
      }
      this.stripePlans.map((row) => {
        row.quantity = 0;
      });
      if (this.interval === this.currentInterval) {
        this.syncPlan();
      }
      this.employeeCount = 0;
      this.chargeAmount = 0;
    },
    // stripePlans: {
    //   handler(val) {
    //     console.log("monthPlan change", val);
    //   },
    //   deep: true,
    // },
  },
  methods: {
    minusQty(row) {
      row.quantity--;
      this.updateEmployeeCount();
      this.$forceUpdate();
    },
    addQty(row) {
      row.quantity++;
      this.updateEmployeeCount();
      this.$forceUpdate();
    },
    async startSub() {
      let obj = {
        interval: this.interval,
        items: [],
      };

      await Promise.all(
        this.stripePlans.map((row) => {
          if (row.quantity >= 1) {
            obj.items.push({
              price: row.id,
              quantity: row.quantity,
            });
          }
        })
      );

      if (obj.items.length === 0) {
        this.$toast.error("No plan was selected", {
          timeout: 5000,
        });
      }

      this.loading = true
      return locationService.Billing.createSubscription(this.location.id, {
        planId: this.stripePlanId,
        items: obj.items,
        customerId: this.customer.id,
      })
        .then(() => {
          this.dialog = false;
          this.$emit("update");
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.$toast.error(err.data ? err.data.message : "Error", {
            timeout: 5000,
          });
        });
    },
    updateEmployeeCount() {
      this.employeeCount = 0;
      this.chargeAmount = 0;
      this.items = [];
      this.stripePlans.map((item) => {
        // console.log('item.quantity', item.employeeCount)
        this.employeeCount +=
          parseInt(item.quantity) * parseInt(item.metadata.employeeCount);
        this.chargeAmount += parseInt(item.quantity) * item.unit_amount;
        if (item.quantity !== 0) {
          this.items.push(item);
        }
      });
    },
    async setPlan() {
      console.log("set plan was called", this.subscription);
      if (this.subscription) {
        this.currentInterval =
          this.subscription.items.data[0].price.recurring.interval;
      }
      console.log("currentInterval", this.currentInterval);
      if (this.currentInterval === "year") {
        console.log("in year");
        this.interval = "year";
        this.planIndex = 1;
      } else {
        this.interval = "month";
        this.planIndex = 0;
      }
      // await Promise.all(
      //   this.subscription.items.data.map((price) => {
      //     this.stripePlans.map((row) => {
      //       if (row.product === price.product) {
      //         row.quantity = price.quantity;
      //       }
      //     });
      //   })
      // );
      console.log("this.plan", this.stripePlans);
    },
    getPlans() {
      publicService
        .GetPlans({ audience: "CUSTOMCLOCKIN" })
        .then(async (response) => {
          console.log("plans", response);
          this.stripePlanId = response.data[0].planId;
          await this.getPriceList();
          // this.plans = response.data
          // if (this.$route.params.plan && response.data.length > 0) {
          //   this.Location.planId = this.$route.params.plan
          //   this.items = response.data[0]
          // }
        });
      this.items = this.plans[this.planIndex];
    },
    syncPlan() {
      if (this.subscription) {
        this.stripePlans.map((row) => {
          this.subscription.items.data.map((price) => {
            if (row.id === price.price.id) {
              row.quantity = price.quantity;
              row.itemId = price.id;
              console.log(
                "dkfjdkfjadkf",
                row.id,
                "===",
                price.price.id,
                "id--> ",
                price.id
              );
            }
          });
        });
      }
    },
    getPriceList() {
      publicService
        .getPriceList({
          stripe: {
            product: this.stripePlanId,
            active: true,
          },
        })
        .then((response) => {
          console.log("price list", response.data);
          this.stripePlans = response.data.data;
          this.stripePlans.map((row) => {
            row.quantity = 0;
          });

          this.syncPlan();
          console.log("price after list done", this.stripePlans);
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error(err.data ? err.data.message : "Error", {
            timeout: 2000,
          });
        });
    },
  },
};
</script>

<style scoped></style>